import { render, staticRenderFns } from "./CardPosicionamentoDados.vue?vue&type=template&id=6aaafe1c"
import script from "./CardPosicionamentoDados.vue?vue&type=script&lang=js"
export * from "./CardPosicionamentoDados.vue?vue&type=script&lang=js"
import style0 from "./CardPosicionamentoDados.vue?vue&type=style&index=0&id=6aaafe1c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports